




























































import { Component, Prop, Vue } from "vue-property-decorator";
import ListInput from "@/components/forms/ListInput.vue";

@Component({
    components: {ListInput}
})

export default class ListInputDialog extends Vue {

    @Prop({default: '', type: String})
    header!: string;

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: '', type: String})
    icon!: string;

    @Prop({default: false, type: Boolean})
    factor!: boolean;

    @Prop({default: '', type: String})
    btnText!: string;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    large: boolean;

    @Prop({default: false, type: Boolean})
    xLarge: boolean;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    @Prop({default: false, type: Boolean})
    isListActive!: boolean;

    @Prop({default: false, type: Boolean})
    addToList!: boolean;

    private dialog: boolean = false;

    private submit(list: any) {
        if (list) {
            this.$emit('submit', list);
            this.dialog = false;
        }
    }

    private cancel() {
        this.dialog = false;
        this.$emit('cancel');
    }

}

